import { Component } from 'preact'
import getWithInMemoryCache from '../../utils/getWithInMemoryCache'
import QuickLinksContainer from '../quick-links/QuickLinksContainer'

export default class KnowledgeBaseQuickLinksWrapper extends Component {
  constructor () {
    super()

    this.state = {
      data: []
    }
  }

  componentDidMount () {
    getWithInMemoryCache('/site/knowledgeBase', {})
      .then(data => this.setState({
        data: data.categoryGroups
      }))
  }

  render (props, state) {
    const { settings, itemsPerContainer, isKnowledgeBase } = props
    const { data } = state
    if (!data.length) {
      return
    }

    return (
      <QuickLinksContainer
        data={data}
        settings={settings}
        isKnowledgeBase={isKnowledgeBase}
        itemsPerContainer={itemsPerContainer} />
    )
  }
}
